import { faMap } from '@fortawesome/free-solid-svg-icons'
import { faIconToSvg } from '~/utils/icon'

export function cyprusButton(title: string, callback: Function) {
  return {
    title, // this.$t('my place'),
    position: 'bottomright',
    event: 'clicked:btnLocation',
    styles: {
      color: '#ffffff',
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      fontSize: '1rem',
      cursor: 'pointer',
      marginRight: '0.625rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '0.1rem 0.5rem 0 0'
    },
    html: `<div><span>${faIconToSvg(faMap)}</span><span>${title}</span></div>`,
    tooltip: 'tooltip',
    callback
  }
}
